//@ts-ignore
//This module is declared with 'export =', and can only be used with a default import when using the 'esModuleInterop' flag.
import React, {ReactElement} from "react";
import {useLocation} from "react-router-dom";
import {getClients} from "../services/ServiceClients";
import IClient from "../interfaces/IClient";
import {Button, Col, ConfigProvider, Form, Space} from "antd";
import ClientIcon from "../components/ClientIcon";

export default function Disconnect(): ReactElement | null {

    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    // Variables
    const query = useQuery();
    const client = query.get("client_id");
    const { clients } = getClients();
    const clientDetails: IClient | undefined = clients?.find((cl) => cl.id === client);

    return (
        <div className="container">
            <ConfigProvider theme={{
                token: {
                    colorPrimary: clientDetails?.color ?? ""
                }
            }}>
                <Form size="large" className="form" initialValues={{ remember: true }}>
                    <Space direction="vertical">
                        <Col className="icon-col">
                            {clientDetails &&
                                <ClientIcon client={clientDetails} size={100} />
                            }
                        </Col>
                        <Form.Item>
                            <ConfigProvider theme={{token: { colorPrimary: clientDetails?.color ?? ""}}}>
                                <Button
                                    href={window.userprofile.path.logout}
                                    className="submit-button"
                                    style={{backgroundColor: clientDetails?.color, color: "white"}}
                                >
                                    Déconnexion
                                </Button>
                            </ConfigProvider>
                        </Form.Item>
                    </Space>
                </Form>
            </ConfigProvider>
        </div>
    )
}